module.exports = __webpack_public_path__ + "img/adverport-logo.23c7b176.png";